export default "__VITE_ASSET__BUzm0EON__"